import { render, staticRenderFns } from "./contactLists.vue?vue&type=template&id=97c02706&scoped=true&"
import script from "./contactLists.vue?vue&type=script&lang=js&"
export * from "./contactLists.vue?vue&type=script&lang=js&"
import style0 from "./contactLists.vue?vue&type=style&index=0&id=97c02706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c02706",
  null
  
)

export default component.exports